import Moment from "moment";

export class DateTimeConverter {
  static toDate(value: string): Date {
    const dateTimeFormat = "YYYYMMDDHHmm";
    const parsed = Moment(value, dateTimeFormat).toDate();
    return !parsed
      ? undefined
      : parsed;
  }
}
